export function inViewport(el, scrollY, args) {
  let options = {
    tolerance: 100,
    horizontal: false,
    parent: null,
  }

  Object.assign(options, args)

  if (!options.horizontal) {
    // const parentOffset = options.parent !== null ? options.parent.offsetTop : 0
    const parentOffset = 0
    const scrollPos = -scrollY + el.h
    const top = el.offsetTop + parentOffset
    const bottom = el.offsetHeight + top

    return bottom + options.tolerance > -scrollY && top - options.tolerance <= scrollPos
  } else {
    const scrollPos = -scrollY + options.w
    const left = el.offsetLeft
    const right = el.offsetWidth + left

    return right + options.tolerance > -scrollY && left - options.tolerance <= scrollPos
  }
}
